/* eslint-disable react-hooks/exhaustive-deps */
import allUsersDispatcher from '../../action';
import MedicalHistory from '../../component/MedicalHistory';
import {
  INIT_DATA_PE_DOCTOR,
  INIT_DATA_PE_PATIENT,
  ROLES_PHYSICALEXAMINATION,
  SURVEY_ANSWER_TYPE,
} from '../../constants';
import SurveyHistory from '../SurveyHistory';
import PersonalInformation from './PersonalInformation';
import PhysicalInformation from './PhysicalInformation';
import { PaperWrapped, HeaderWrapped } from './styled';
import LoadingButton from '@/components/LoadingButton';
import { urlLabel } from '@/enum/PermissionEnum';
import { getNumberInfo, momentFormatted, renderUnitNumber } from '@/helpers';
import validateData from '@/helpers/validationHelpers/validationSchema';
import TabsUI from '@/module/common/componentUI/TabsUI';
import { ButtonEnhance } from '@/module/common/componentUI/commonStyleComponents';
import patientDispatcher from '@/module/patient/actions';
import {
  LIST_REQUIRED,
  LIST_REQUIRED_CHILDREN,
  LIST_LV1_REQUIRED,
} from '@/module/patient/constants';
import { TeleAppointmentManagement } from '@/module/tele-appointment';
import customToast from '@/new-components/CustomNotification';
import globalDispatcher from '@/redux/global/actions';
import {
  checkRegexFullName,
  isMaskedValue,
  validateDateOfBirth,
  validateEmail,
  validateIdentity,
  validateMobile,
  validateNRIC,
} from '@/utils/validation';
import { Typography } from '@material-ui/core';
import { get, isEmpty, cloneDeep } from 'lodash';
import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';

const UserDetail = () => {
  const { loading } = useSelector((state) => state.allUsers);
  const roleType = useSelector((state) => state.auth.roleType);

  const [userFullName, setUserFullName] = useState('');
  const [personalInfo, setPersonalInfo] = useState({
    countryCode: 64,
    identityType: 'NRIC',
  });
  const [unitNumber, setUnitNumber] = useState('');
  const [errors, setErrors] = useState({});

  const [currentTab, setCurrentTab] = useState(0);
  const [isDoctorSide, setIsDoctorSide] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const location = useLocation();
  const history = useHistory();
  const userID = get(location, 'state.id');
  const selectedItem = get(location, 'state');
  const [currentSelectValue, setCurrentSelectValue] = useState({});

  const physicalExamInfoDoctor = INIT_DATA_PE_DOCTOR.sections;
  const physicalExamInfoPatient = INIT_DATA_PE_PATIENT;
  const [dataPEDoctor, setDataPEDoctor] = useState({
    doctorJsonData: null,
    doctorSubmittedDate: null,
    paxScreeningId: null,
  });
  const [dataPEPatient, setDataPEPatient] = useState({
    patientJsonData: null,
    patientSubmittedDate: null,
    paxScreeningId: null,
  });
  const [physicalExamInfo, setPhysicalExamInfo] = useState([]);
  const [lstIdentityUrl, setLstIdentityUrl] = useState([]);
  // Patient Info
  const [isChildren, setIsChildren] = useState(false);

  useEffect(() => {
    if (!userID)
      return history.push({
        pathname: `/${urlLabel.userDetails}`,
      });

    allUsersDispatcher.getUserDetail(userID, (result) => {
      if (!isEmpty(result)) {
        if (!selectedItem.email) {
          setIsChildren(true);
        }
        const unitNumber = renderUnitNumber(result.floor, result.unitNumber);
        setUnitNumber(unitNumber);
        setPersonalInfo({
          ...selectedItem,
          patientShortId: result.patientShortId,
          totalMoneyUsed: result.totalMoneyUsed,
          identityNumber: result.nric,
        });
        setUserFullName(result.fullName);
        fetchDataPhysicalHistories(result.id);
      }
    });
    if (userID) {
      globalDispatcher.getIdentityImages(userID, (data) => {
        setLstIdentityUrl(data);
      });
    }
  }, []);

  const resetDoctorJsonData = (dataDoctor) => {
    const resetData = dataDoctor.map((section) => ({
      ...section,
      options: section.options.map((opt) => ({
        ...opt,
        valueSelected: null,
        list: opt.list.map((ans) =>
          ans.hasOwnProperty('detail') ? { ...ans, detail: null } : ans
        ),
      })),
    }));
    return resetData;
  };

  const resetPatientJsonData = (dataClient) => {
    const resetData = dataClient.map((section) => ({
      ...section,
      questions: section.questions.map((ques) => ({
        ...ques,
        answers: ques.answers.map((ans) => ({
          ...ans,
          isSelected: false,
          patientNote: '',
        })),
      })),
    }));
    return resetData;
  };

  const isJsonString = (item) => {
    item = typeof item !== 'string' ? JSON.stringify(item) : item;

    try {
      item = JSON.parse(item);
    } catch (e) {
      return false;
    }

    if (typeof item === 'object' && item !== null) {
      return true;
    }

    return false;
  };
  const fetchDataPhysicalHistories = async (id, refreshAfterEdit = false) => {
    allUsersDispatcher.getPhysicalHistories(id, (data = []) => {
      const newData = data.map((d) => {
        const isCheckDoctor = isJsonString(d.doctorJsonData);
        const isCheckPatient = isJsonString(d.patientJsonData);

        const doctorJsonData = isCheckDoctor
          ? JSON.parse(d.doctorJsonData)
          : resetDoctorJsonData(physicalExamInfoDoctor);
        const patientJsonData = isCheckPatient
          ? JSON.parse(d.patientJsonData)
          : resetPatientJsonData(physicalExamInfoPatient);
        return {
          ...d,
          doctorJsonData,
          patientJsonData,
        };
      });
      if (!isEmpty(currentSelectValue) && !refreshAfterEdit) {
        if (
          currentSelectValue.doctorSubmittedDate ||
          currentSelectValue.patientSubmittedDate
        ) {
          const newCurrentSelect = newData.find(
            (item) => item.id === currentSelectValue.id
          );
          setCurrentSelectValue(newCurrentSelect);
        } else {
          if (isDoctorSide) {
            setCurrentSelectValue({
              ...currentSelectValue,
              doctorJsonData: resetDoctorJsonData(
                currentSelectValue.doctorJsonData
              ),
            });
          } else {
            setCurrentSelectValue({
              ...currentSelectValue,
              patientJsonData: resetPatientJsonData(
                currentSelectValue.patientJsonData
              ),
            });
          }
        }
      } else {
        setCurrentSelectValue(newData[0]);
      }
      if (!isEmpty(newData)) setPhysicalExamInfo(newData);
    });
  };

  const onCancel = () => history.goBack();

  const onCheckValidForm = () => {
    let valid = true;
    let errors = {};
    let listRequired = [];

    if (isChildren) {
      listRequired = LIST_REQUIRED_CHILDREN;
    } else if (!personalInfo.isRegisterLv2) {
      listRequired = LIST_LV1_REQUIRED;
    } else {
      listRequired = LIST_REQUIRED;
    }

    listRequired.forEach((field) => {
      if (!personalInfo[field]) {
        errors = { ...errors, [field]: 'Required' };
        valid = false;
      }
    });

    if (personalInfo.fullName) {
      const isValidFullName = checkRegexFullName(personalInfo.fullName);
      if (!isValidFullName) {
        errors = {
          ...errors,
          fullName:
            'Full Name must contain letters only or letters combined with special characters',
        };
        valid = false;
      }
    }

    const statusDateOfBirth = validateDateOfBirth(personalInfo.dateOfBirth);
    if (statusDateOfBirth && !statusDateOfBirth.valid) {
      errors = { ...errors, dateOfBirth: statusDateOfBirth.message };
      valid = false;
    }

    if (personalInfo.email) {
      let regex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!regex.test(personalInfo.email)) {
        errors = { ...errors, email: 'Email is invalid' };
        valid = false;
      }
    }

    if (personalInfo.notificationEmail) {
      let regex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!regex.test(personalInfo.notificationEmail)) {
        errors = {
          ...errors,
          notificationEmail: 'Notification email is invalid',
        };
        valid = false;
      }
    }

    if (personalInfo.mobile && !isMaskedValue(personalInfo.mobile)) {
      const validMobile = validateMobile(
        personalInfo.mobile,
        personalInfo.countryCode
      );
      if (!validMobile) {
        errors = { ...errors, mobile: 'Mobile is invalid' };
        valid = false;
      }
    }

    if (!personalInfo.isRegisterLv2 && !isChildren) {
      setErrors(errors);
      return valid;
    }

    if (!personalInfo.identityType) {
      errors = { ...errors, identityType: 'Type of ID is required' };
      valid = false;
      setErrors(errors);
      return valid;
    }

    if (
      personalInfo.identityNumber &&
      !isMaskedValue(personalInfo.identityNumber)
    ) {
      const validIdentityNumber =
        personalInfo.identityType === 'NRIC'
          ? validateNRIC(personalInfo.identityNumber)
          : validateIdentity(personalInfo.identityNumber);

      if (!validIdentityNumber) {
        errors = { ...errors, identityNumber: 'Identity Number is invalid' };
        valid = false;
      }
    }

    if (personalInfo.isRegisterLv2 && !isChildren) {
      if (!isEmpty(personalInfo.corporatePlans)) {
        let newCorporatePlans = cloneDeep(personalInfo.corporatePlans);

        newCorporatePlans = newCorporatePlans.map((item) => {
          if (!item.corporatePlanType) {
            valid = false;
            return {
              ...item,
              errors: {
                ...errors,
                corporateName: 'Corporate Name is required',
              },
            };
          } else return item;
        });

        personalInfo.corporatePlans = newCorporatePlans;
      }
    }
    // Unit Number validation:
    // - Address is optional when unit number is empty.
    // - Unit number is not allowed when address is empty.
    const hasAddress = !isEmpty(personalInfo.address);
    const hasFloor = !isEmpty(personalInfo.floor);
    const hasUnit = !isEmpty(personalInfo.unitNumber);
    const hasAnyUnitValue = hasFloor || hasUnit;
    const normalizedUnitInput = (unitNumber || '').trim();
    const hasUnitInput = !isEmpty(normalizedUnitInput);
    const isUnitInputFormatValid =
      hasFloor &&
      hasUnit &&
      personalInfo.floor?.length === 2 &&
      normalizedUnitInput.indexOf('-') === 2;

    if (hasUnitInput && !isUnitInputFormatValid) {
      errors = {
        ...errors,
        unitNumber: 'Unit Number is invalid',
      };
      valid = false;
    } else if (!hasAddress && hasAnyUnitValue) {
      errors = {
        ...errors,
        address: 'Address is required',
      };
      valid = false;
    } else if (hasAddress && hasAnyUnitValue && !isUnitInputFormatValid) {
      errors = {
        ...errors,
        unitNumber: 'Unit Number is invalid',
      };
      valid = false;
    }

    if ((hasAddress || hasAnyUnitValue) && isEmpty(personalInfo.postalCode)) {
      errors = {
        ...errors,
        postalCode: 'Postal Code is required',
      };
      valid = false;
    }

    if (!personalInfo.address && personalInfo.hasDefaultAddress) {
      errors = {
        ...errors,
        address: 'Can not delete default delivery address',
      };
      valid = false;
    }

    setErrors(errors);
    return valid;
  };

  const buildAddressPayload = (data) => ({
    userId: data?.userId,
    address: data?.address,
    unitNumber: data?.unitNumber,
    postalCode: data?.postalCode,
    isDefault: true,
    longitude: data?.longitude || 0,
    latitude: data?.latitude || 0,
    floor: data?.floor,
    ignoredUnitNumber: data?.ignoredUnitNumber,
  });

  const fetchUserAddresses = (userId) =>
    new Promise((resolve) => {
      patientDispatcher.getUserAddress(userId, (addresses) => {
        resolve(addresses || []);
      });
    });

  const upsertDefaultAddress = async (data) => {
    const payload = buildAddressPayload(data);
    const addresses = await fetchUserAddresses(data.userId);
    const defaultAddress = addresses.find((item) => item?.isDefault);

    return new Promise((resolve) => {
      if (!isEmpty(defaultAddress?.id)) {
        patientDispatcher.editUserAddress(
          {
            ...payload,
            id: defaultAddress.id,
          },
          resolve,
          resolve
        );
        return;
      }

      patientDispatcher.createUserAddress(payload, resolve, resolve);
    });
  };

  const refreshUserDetailAfterSave = (userId) => {
    allUsersDispatcher.getUserDetail(userId, (result) => {
      if (!isEmpty(result)) {
        if (!result.email) {
          setIsChildren(true);
        }
        setUserFullName(result.fullName);
        fetchDataPhysicalHistories(result.id);
      }
    });
    globalDispatcher.getIdentityImages(userId, (data) => {
      setLstIdentityUrl(data);
    });
  };

  const onUpdatePatientSuccess = async (newPersonalInfo) => {
    const hasAddress = !isEmpty(newPersonalInfo?.address);
    const hasFloor = !isEmpty(newPersonalInfo?.floor);
    const hasUnit = !isEmpty(newPersonalInfo?.unitNumber);

    // Skip default-address upsert when address + unit are both empty
    // to avoid backend required-address validation error.
    if (hasAddress || hasFloor || hasUnit) {
      await upsertDefaultAddress(newPersonalInfo);
    }
    refreshUserDetailAfterSave(newPersonalInfo.userId);
  };

  const onSavePersonalInfo = async () => {
    if (!onCheckValidForm()) {
      return;
    }

    setErrors({});

    let newPersonalInfo = {
      fullName: personalInfo?.fullName,
      email: personalInfo?.email,
      notificationEmail: personalInfo?.notificationEmail,
      dateOfBirth:
        moment(personalInfo?.dateOfBirth).format('YYYY-MM-DDT00:00:00.000') +
        'Z',
      gender: personalInfo?.gender,
      address: personalInfo?.address,
      mobile: personalInfo?.mobile,
      nationality: personalInfo?.nationality,
      unitNumber: personalInfo?.unitNumber,
      countryCode: personalInfo?.countryCode,
      userId: personalInfo?.id,
      lstIdentityUrl: personalInfo?.lstIdentityUrl,
      identityNumber: personalInfo?.identityNumber,
      latitude: personalInfo?.latitude,
      longitude: personalInfo?.longitude,
      identityType: personalInfo.identityType,
      corporatePlans: personalInfo.corporatePlans,
      postalCode: personalInfo.postalCode,
      floor: personalInfo.floor,
      projectCode: personalInfo.projectCode,
      ignoredUnitNumber: personalInfo.ignoredUnitNumber,
      ethnicGroup: personalInfo.ethnicGroup,
      highlight: personalInfo.highlight,
    };

    // Clean up corporate plans errors if they exist
    if (!isEmpty(newPersonalInfo.corporatePlans)) {
      const corporatePlans = cloneDeep(newPersonalInfo.corporatePlans).map(
        (item) => (item.errors ? delete item.errors : item)
      );
      newPersonalInfo.corporatePlans = corporatePlans;
    }

    const mobile = getNumberInfo(
      newPersonalInfo.mobile,
      newPersonalInfo.countryCode
    )[0];

    if (!isEmpty(newPersonalInfo.lstIdentityUrl)) {
      try {
        const lstIdentityUrl = await uploadFiles(
          newPersonalInfo.lstIdentityUrl
        );

        patientDispatcher.updatePatient(
          { ...newPersonalInfo, lstIdentityUrl, mobile },
          () => onUpdatePatientSuccess(newPersonalInfo)
        );
      } catch (error) {
        console.error('Failed to upload files:', error);
      }
    } else {
      patientDispatcher.updatePatient({ ...newPersonalInfo, mobile }, () =>
        onUpdatePatientSuccess(newPersonalInfo)
      );
    }
  };

  const uploadFileAndGetURL = async (file) => {
    const timeStamp = new Date().getTime();
    const fileName = `${timeStamp}${file.name}`;
    const formdata = new FormData();
    formdata.append('file', file, fileName);

    return new Promise((resolve, reject) => {
      globalDispatcher.uploadIdentityImage(formdata, (result) => {
        if (result) {
          resolve(result);
        } else {
          reject('Upload failed');
        }
      });
    });
  };

  const uploadFiles = async (fileList) => {
    const uploadPromises = fileList.map((file) => {
      if (file?.constructor === File) {
        return uploadFileAndGetURL(file);
      }
      return Promise.resolve(file); // Trả về file nếu nó không phải là một đối tượng File
    });

    return Promise.all(uploadPromises);
  };

  const validatePhysicalExam = () => {
    // Doctor PE
    const dataDoctor = dataPEDoctor.doctorJsonData;
    const dataPatient = dataPEPatient.patientJsonData;

    let isNoPatientNote = false;
    let isNoDoctortNote = false;
    let isForceSelected = false;
    let isSelectAtLeastOne = false;

    dataDoctor.forEach((data) => {
      data.options.forEach((option) => {
        const noDoctorNote = option.list.some(
          (item) =>
            item.hasOwnProperty('detail') &&
            item.value === option.valueSelected &&
            isEmpty(item.detail)
        );
        if (noDoctorNote) isNoDoctortNote = true;
      });
    });

    // Client PE
    dataPatient.forEach((data) => {
      data.questions.forEach((question) => {
        const newOtionsParent = data.questions.find(
          (item) => item.id === question.mapParentQuestionId
        );

        const newOtionsChild = data.questions.find(
          (item) => item.mapParentQuestionId === question.mapParentQuestionId
        );

        const newOtionsChildSingle = data.questions.filter(
          (item) => item.answerType === SURVEY_ANSWER_TYPE.SingleChoice
        );

        const noPatientNote = question.answers.some(
          (answer) =>
            answer.isAdditional &&
            answer.isSelected &&
            isEmpty(answer.patientNote)
        );
        if (noPatientNote) isNoPatientNote = true;

        if (newOtionsParent && newOtionsChild) {
          const isParentActive = newOtionsParent?.answers.find(
            (item) => item.isSelected
          );
          const isChildActive = newOtionsChild.answers.filter(
            (answer) => answer.isSelected
          );

          if (isParentActive) {
            if (!isEmpty(newOtionsChildSingle)) {
              let isChildActive = [];
              let isChildTotal = [];
              newOtionsChildSingle.forEach((item) => {
                const itemSelected = item.answers.find((it) => it.isSelected);
                isChildTotal = isChildTotal.concat(item.answers);
                if (itemSelected) isChildActive.push(itemSelected);
              });

              // Need to divide into 2 for single choice select, 1 question have 2 answers (YES and NO)
              if (isChildTotal.length / 2 === isChildActive.length) {
                isForceSelected = false;
              } else isForceSelected = true;
            }
            if (!isEmpty(isChildActive)) {
              isSelectAtLeastOne = false;
            } else {
              isSelectAtLeastOne = true;
            }
          }
        }
      });
    });

    if (isNoPatientNote)
      setErrors({ ...errors, patientNote: 'The detail is required!' });
    if (isNoDoctortNote)
      setErrors({ ...errors, doctorNote: 'The detail is required!' });
    else if (isSelectAtLeastOne) {
      setErrors({
        ...errors,
        atLeastChooseAnswer: 'You need to choose at least option!',
      });
    }
    if (isForceSelected) {
      setErrors({
        ...errors,
        forceAnswer: 'This question is required!',
      });
    }

    return {
      isNoPatientNote,
      isForceSelected,
      isSelectAtLeastOne,
      isNoDoctortNote,
    };
  };
  const onSavePhysicalExam = async () => {
    const {
      isNoPatientNote,
      isForceSelected,
      isSelectAtLeastOne,
      isNoDoctortNote,
    } = validatePhysicalExam();
    try {
      if (
        isNoPatientNote ||
        isForceSelected ||
        isSelectAtLeastOne ||
        isNoDoctortNote
      ) {
        customToast(
          'error',
          'Please enter the answer before saving your change!'
        );
      } else {
        if (dataPEDoctor.paxScreeningId) {
          const doctorJsonData = JSON.stringify(dataPEDoctor.doctorJsonData);

          const patientJsonData =
            // Doctor PE submit without client PE
            isDoctorSide && !dataPEPatient.patientSubmittedDate
              ? null
              : JSON.stringify(dataPEPatient.patientJsonData);

          allUsersDispatcher.updateDoctorPE(
            {
              paxScreeningId: dataPEDoctor.paxScreeningId,
              patientJsonData,
              doctorJsonData,
            },
            () => {
              fetchDataPhysicalHistories(personalInfo.id, true);
              setIsEdit(false);
              setErrors({});
            }
          );
        }
      }
    } catch (err) {
      setErrors(err);
    }
  };

  const userDetailTabs = [
    {
      label: 'Personal Information',
      body: (
        <PersonalInformation
          errors={errors}
          personalInfo={personalInfo}
          setPersonalInfo={setPersonalInfo}
          lstIdentityUrl={lstIdentityUrl}
          isChildren={isChildren}
          unitNumber={unitNumber}
          setUnitNumber={setUnitNumber}
        />
      ),
      header: (
        <div className="personal-btn">
          <ButtonEnhance
            background="#E9E9E9"
            color="black"
            backgroundHover="#ccc"
            onClick={onCancel}
          >
            Cancel
          </ButtonEnhance>
          <LoadingButton onClick={onSavePersonalInfo} showLoader={loading}>
            Save Change
          </LoadingButton>
        </div>
      ),
    },
    {
      label: 'Appointments',
      body: <TeleAppointmentManagement userId={userID} showToolbar={false} />,
    },
    {
      label: 'Medical History',
      body: <MedicalHistory userId={userID} />,
    },
    {
      label: 'Physical Examination',
      body: (
        <PhysicalInformation
          isDoctorSide={isDoctorSide}
          isEdit={isEdit}
          setIsDoctorSide={setIsDoctorSide}
          dataPEDoctor={dataPEDoctor}
          setDataPEDoctor={setDataPEDoctor}
          dataPEPatient={dataPEPatient}
          setDataPEPatient={setDataPEPatient}
          physicalExamInfo={physicalExamInfo}
          currentSelectValue={currentSelectValue}
          setCurrentSelectValue={setCurrentSelectValue}
          errors={errors}
        />
      ),
      header: isEdit ? (
        <div className="personal-btn">
          <ButtonEnhance
            background="#E9E9E9"
            color="black"
            backgroundHover="#ccc"
            onClick={() => {
              fetchDataPhysicalHistories(personalInfo.id);
              setIsEdit(false);
              setErrors({});
            }}
          >
            Cancel
          </ButtonEnhance>
          <LoadingButton onClick={onSavePhysicalExam} showLoader={loading}>
            Save Change
          </LoadingButton>
        </div>
      ) : (
        ROLES_PHYSICALEXAMINATION.includes(roleType) && (
          <LoadingButton onClick={() => setIsEdit(true)} showLoader={loading}>
            Edit
          </LoadingButton>
        )
      ),
    },
    {
      label: 'Survey',
      body: <SurveyHistory personalInfo={personalInfo} />,
    },
    {
      label: 'Health Analytics',
      body: <div>Coming soon...</div>,
    },
    {
      label: 'Family Information',
      body: <div>Coming soon...</div>,
    },
    {
      label: 'Engagements',
      body: <div>Coming soon...</div>,
    },
    {
      label: 'Health Profile',
      body: <div>Coming soon...</div>,
    },
  ];

  return (
    <PaperWrapped>
      <HeaderWrapped>
        <Typography className="title">{userFullName}</Typography>
        {userDetailTabs[currentTab].header}
      </HeaderWrapped>
      <TabsUI
        listTab={userDetailTabs}
        value={currentTab}
        onChange={(e, val) => {
          setCurrentTab(val);
        }}
        renderLabel="label"
        renderKey="label"
      />
      {userDetailTabs[currentTab].body}
    </PaperWrapped>
  );
};

export default UserDetail;
